export var handleDisableBtn = function (formError, inputErrors) {
    return (Object.keys(formError).length > 0 ||
        Object.values(inputErrors).some(function (item) { return item !== 'success'; }));
};
export var makeGuestRequestBody = function (orderId, emailId, phone) {
    if (phone) {
        return {
            orderDetailsRequest: {
                searchType: 'instore',
                phoneNumber: phone,
                orderNumber: orderId,
                groupAndSortBy: {
                    filterResponse: true,
                    groupBy: 'fulfillmentType',
                },
            },
        };
    }
    return {
        orderDetailsRequest: {
            searchType: 'online',
            emailId: emailId,
            orderNumber: orderId,
            groupAndSortBy: {
                filterResponse: true,
                groupBy: 'fulfillmentType',
            },
        },
    };
};
